<template>
    <div class="form-group" :class="{ 'disabled': disabled }">
        <label class="block" :class="{'sr-only': srOnly }">{{ label }}</label>
        <div class="btn-group block">
            <a 
                v-if="!noFirst"
                class="btn" 
                :class="value ? 'btn-success' : 'btn-secondary'" 
                @click="toggle(true)" 
                :aria-label="innerYesLabel"
            >
                {{ innerYesLabel }}
            </a>
            <a 
                class="btn" 
                :class="value ? 'btn-secondary' : 'btn-success'"
                @click="toggle(false)" 
                :aria-label=innerNoLabel
            >
                {{ innerNoLabel }}
            </a>
            <a 
                v-if="noFirst"
                class="btn" 
                :class="value ? 'btn-success' : 'btn-secondary'" 
                @click="toggle(true)" 
                :aria-label="innerYesLabel"
            >
                {{ innerYesLabel }}
            </a>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        yesLabel: {
            type: String,
            default: '',
        },
        noLabel: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            required: true,
        },
        srOnly: {
            type: Boolean,
            default: false,
        },
        noFirst: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        toggle(val) {
            this.$emit('input', val)
        }
    },
    computed: {
        innerYesLabel() { return this.yesLabel ? this.yesLabel : this.$t('yes') },
        innerNoLabel() { return this.noLabel ? this.noLabel: this.$t('no') }
    }
}
</script>

<style scoped lang="scss">
    .disabled {
        opacity: 0.8;
        pointer-events: none;
    }
</style>